import React, { useState } from 'react';

import { API } from 'constants';
import client from '../../../../services/library-api';

import { defaultErrorMessage } from '../../../../constants/errorMessages';

import ConfirmDeletionModalPattern from '../../../../design-system/ConfirmDeletionModalPattern/ConfirmDeletionModalPattern';

const ConfirmDeleteWebhookNotificationModal = ({
    agentId,
    notification,
    setWebhookNotifications,
    setSuccessAlert,
    onClose,
}) => {
    const { id, name } = notification;

    const [isLoading, setIsLoading] = useState(false);
    const [errorAlert, setErrorAlert] = useState(null);

    const handleDelete = async () => {
        try {
            setIsLoading(true);

            await client.delete(API.ROUTES.library.process + agentId + '/event/' + id + '/');
            setWebhookNotifications((prevNotifications) =>
                prevNotifications.filter((notification) => notification.id !== id)
            );

            setSuccessAlert({ message: 'Webhook notification successfully deleted' });
            onClose();
        } catch (e) {
            setIsLoading(false);
            setErrorAlert({ message: defaultErrorMessage, statusCode: e.response?.status });
        }
    };

    return (
        <ConfirmDeletionModalPattern
            variant="secondary"
            title="Delete Webhook?"
            onClose={onClose}
            confirmationTextStart="Are you sure you want to delete"
            confirmationTextEnd="This event will no longer be used to trigger notifications for this agent."
            entityName={`${name}?`}
            handleDelete={handleDelete}
            isLoading={isLoading}
            errorAlert={errorAlert}
            setErrorAlert={setErrorAlert}
            buttonsTheme="colored"
        />
    );
};

export default ConfirmDeleteWebhookNotificationModal;
